import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import { SonicDBEntry } from "../../common/classes/SonicDBEntry";
import { getDefaultImage } from "../../utils/GeneralUtils";
import styles from "./TeamMembers.module.scss";
import SonicLink from "../../common/routing/SonicLink";

type Props = {
  members: SonicDBEntry[];
};

const TeamMembers: React.FC<Props> = ({ members }) => {
  return (
    <div className={styles["f-members"]}>
      <p className={styles["f-members__title"]}>ー TEAM MEMBERS</p>
      <Swiper
        className={styles["f-members__slider"]}
        slidesPerView={"auto"}
        spaceBetween={16}
        modules={[Navigation]}
      >
        {members.map((member) => (
          <SwiperSlide
            className={styles["f-members__slider-item"]}
            key={member.id}
          >
            <SonicLink to={`/person/${member.id}`}>
              <div className={styles["imgBox"]}>
                <img
                  src={
                    member.imgs ? member.imgs[0].medium.url : getDefaultImage()
                  }
                />
              </div>
            </SonicLink>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default TeamMembers;
